// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== 1. Hero Section ===== */
.ServiciosIA_heroSection__0BNq9 {
  position: relative;
  text-align: center;
  padding: 120px 5% 100px 5%;
  color: var(--textoBlanco);
  overflow: hidden;
  background-color: #111;
}

.ServiciosIA_heroBackground__StL22 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
  opacity: 0.4; 
}

.ServiciosIA_heroContent__TAZWz {
  position: relative;
  z-index: 2;
  max-width: 800px;
  margin: 0 auto;
}

.ServiciosIA_heroSection__0BNq9 h1 {
  font-size: 48px;
  font-weight: 800;
  color: var(--textoBlanco);
  line-height: 1.2;
}

.ServiciosIA_heroSection__0BNq9 p {
  font-size: 18px;
  margin: 25px 0 40px 0;
  color: #e0e0e0;
  line-height: 1.7;
}

.ServiciosIA_ctaButton__RvenQ {
  background-color: var(--naranja);
  color: var(--textoBlanco);
  padding: 15px 35px;
  border-radius: 5px;
  font-weight: 700;
  font-size: 18px;
  transition: all 0.3s ease;
}
.ServiciosIA_ctaButton__RvenQ:hover {
  background-color: var(--azul);
}

/* ===== 2. Servicios Section ===== */
.ServiciosIA_servicesSection__cPVgS {
  padding: 80px 0;
  margin-bottom: -4.3%; 
}

.ServiciosIA_serviceItem__yb8RY {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 0;
  background-color: #e6effa;
}
.ServiciosIA_serviceItem__yb8RY:nth-child(even) .ServiciosIA_imageWrapper__JOOfL {
  order: 2;
}
.ServiciosIA_serviceItem__yb8RY:nth-child(even) .ServiciosIA_contentWrapper__-MLQW {
  order: 1;
}

.ServiciosIA_imageWrapper__JOOfL {
  width: 100%;
  height: 500px;
}

.ServiciosIA_serviceImage__0ARUo {
  width: 100%;
  height: 500px;
  object-fit: cover;
  display: block; 
}

.ServiciosIA_contentWrapper__-MLQW {
  padding: 60px 8%;
  text-align: left;
}

.ServiciosIA_contentWrapper__-MLQW h2 {
  font-size: 28px;
  font-weight: 700;
  color: #000000;
  margin-bottom: 15px;
}

.ServiciosIA_contentWrapper__-MLQW p {
  font-size: 16px;
  color: #000000;
  line-height: 1.7;
  margin-bottom: 25px;
}

.ServiciosIA_learnMoreLink__Z76yd {
  background-color: var(--naranja);
  color: var(--textoBlanco);
  padding: 15px 35px;
  border-radius: 5px;
  font-weight: 700;
  font-size: 18px;
  transition: all 0.3s ease;
}
.ServiciosIA_learnMoreLink__Z76yd:hover {
  background-color: var(--azul);
}


/* ===== Contenedor Principal de la Sección ===== */
.ServiciosIA_uniqueNeedsSection__\\+dHAz {
  background-color: #000000; 
  color: #fff
}

.ServiciosIA_containerExtra__FcMXk {
  max-width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 0;
}

/* ===== Columna de Imagen (Derecha en Desktop) ===== */
.ServiciosIA_imageWrapper__JOOfL {
  width: 100%;
  height: 100%;
}

.ServiciosIA_image__-qM-Q {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* ===== Columna de Contenido (Izquierda en Desktop) ===== */
.ServiciosIA_contentWrapperExtra__ZEjEJ {
  padding: 40px 8%;
  text-align: left;
}

.ServiciosIA_title__IMNzb {
  font-weight: 800;
  margin-bottom: 20px;
}

.ServiciosIA_contentWrapperExtra__ZEjEJ h2 {
    font-size: 40px;
    color: #ffffff;
}

.ServiciosIA_title__IMNzb span {
  color: var(--azul);
    font-size: 34px;
  font-weight: 800;
  margin-bottom: 20px;
  line-height: 1.3;

}

.ServiciosIA_paragraph__zEVTX {
  font-size: 16px;
  color: #ffffff;
  line-height: 1.7;
  margin-bottom: 30px;
}

.ServiciosIA_paragraph__zEVTX p {
    color: #fff;
}

/* ===== Lista de Necesidades ===== */
.ServiciosIA_needsList__u9\\+Pa {
  list-style: none;
  padding: 0;
  margin: 0 0 40px 0;
  display: flex;
  flex-direction: column;
  gap: 15px; /* Espacio entre ítems de la lista */
}

.ServiciosIA_needsItem__P7GBb {
  display: flex;
  align-items: center;
  gap: 15px;
  font-size: 16px;
  color: #d0d0d0;
}

.ServiciosIA_needsItem__P7GBb svg {
  flex-shrink: 0; /* Evita que el ícono se encoja */
  width: 24px;
  height: 24px;
  color: var(--azul); /* Color azul para el ícono */
}

/* ===== Tagline Final ===== */
.ServiciosIA_tagline__ky6NL {
  font-size: 28px;
  font-weight: 700;
  color: var(--textoBlanco);
  line-height: 1.4;
}

.ServiciosIA_tagline__ky6NL span {
  color: var(--azul);
  font-size: 28px;
}

/* ===== MEDIA QUERY PARA MÓVILES ===== */
@media (max-width: 767px) {
  .ServiciosIA_heroSection__0BNq9 h1 { font-size: 34px; }
  .ServiciosIA_heroSection__0BNq9 p { font-size: 16px; }
  .ServiciosIA_learnMoreLink__Z76yd {
    font-size: 14px;
  }
  .ServiciosIA_serviceItem__yb8RY {
    grid-template-columns: 1fr; 
  }
  .ServiciosIA_serviceItem__yb8RY:nth-child(even) .ServiciosIA_imageWrapper__JOOfL,
  .ServiciosIA_serviceItem__yb8RY:nth-child(even) .ServiciosIA_contentWrapper__-MLQW {
    order: initial;
  }
  .ServiciosIA_contentWrapper__-MLQW {
    padding: 40px 8%;
  }
  .ServiciosIA_contentWrapper__-MLQW h2 {
    font-size: 24px;
  }
  .ServiciosIA_containerExtra__FcMXk {
    grid-template-columns: 1fr;
  }
  .ServiciosIA_contentWrapperExtra__ZEjEJ {
    order: 2;
    padding: 40px 8%;
  }
  .ServiciosIA_title__IMNzb {
    font-size: 28px;
  }
  .ServiciosIA_tagline__ky6NL {
    font-size: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ServiciosIA.module.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,MAAM;EACN,yBAAyB;AAC3B;AACA;EACE,QAAQ;AACV;AACA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;;;AAGA,mDAAmD;AACnD;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,MAAM;AACR;;AAEA,uDAAuD;AACvD;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,4DAA4D;AAC5D;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;EACE,kBAAkB;IAChB,eAAe;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;;AAElB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,oCAAoC;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc,EAAE,iCAAiC;EACjD,WAAW;EACX,YAAY;EACZ,kBAAkB,EAAE,6BAA6B;AACnD;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE,qCAAkB,eAAe,EAAE;EACnC,oCAAiB,eAAe,EAAE;EAClC;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,QAAQ;IACR,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ===== 1. Hero Section ===== */\n.heroSection {\n  position: relative;\n  text-align: center;\n  padding: 120px 5% 100px 5%;\n  color: var(--textoBlanco);\n  overflow: hidden;\n  background-color: #111;\n}\n\n.heroBackground {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  z-index: 1;\n  opacity: 0.4; \n}\n\n.heroContent {\n  position: relative;\n  z-index: 2;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.heroSection h1 {\n  font-size: 48px;\n  font-weight: 800;\n  color: var(--textoBlanco);\n  line-height: 1.2;\n}\n\n.heroSection p {\n  font-size: 18px;\n  margin: 25px 0 40px 0;\n  color: #e0e0e0;\n  line-height: 1.7;\n}\n\n.ctaButton {\n  background-color: var(--naranja);\n  color: var(--textoBlanco);\n  padding: 15px 35px;\n  border-radius: 5px;\n  font-weight: 700;\n  font-size: 18px;\n  transition: all 0.3s ease;\n}\n.ctaButton:hover {\n  background-color: var(--azul);\n}\n\n/* ===== 2. Servicios Section ===== */\n.servicesSection {\n  padding: 80px 0;\n  margin-bottom: -4.3%; \n}\n\n.serviceItem {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  align-items: center;\n  gap: 0;\n  background-color: #e6effa;\n}\n.serviceItem:nth-child(even) .imageWrapper {\n  order: 2;\n}\n.serviceItem:nth-child(even) .contentWrapper {\n  order: 1;\n}\n\n.imageWrapper {\n  width: 100%;\n  height: 500px;\n}\n\n.serviceImage {\n  width: 100%;\n  height: 500px;\n  object-fit: cover;\n  display: block; \n}\n\n.contentWrapper {\n  padding: 60px 8%;\n  text-align: left;\n}\n\n.contentWrapper h2 {\n  font-size: 28px;\n  font-weight: 700;\n  color: #000000;\n  margin-bottom: 15px;\n}\n\n.contentWrapper p {\n  font-size: 16px;\n  color: #000000;\n  line-height: 1.7;\n  margin-bottom: 25px;\n}\n\n.learnMoreLink {\n  background-color: var(--naranja);\n  color: var(--textoBlanco);\n  padding: 15px 35px;\n  border-radius: 5px;\n  font-weight: 700;\n  font-size: 18px;\n  transition: all 0.3s ease;\n}\n.learnMoreLink:hover {\n  background-color: var(--azul);\n}\n\n\n/* ===== Contenedor Principal de la Sección ===== */\n.uniqueNeedsSection {\n  background-color: #000000; \n  color: #fff\n}\n\n.containerExtra {\n  max-width: 100%;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  align-items: center;\n  gap: 0;\n}\n\n/* ===== Columna de Imagen (Derecha en Desktop) ===== */\n.imageWrapper {\n  width: 100%;\n  height: 100%;\n}\n\n.image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* ===== Columna de Contenido (Izquierda en Desktop) ===== */\n.contentWrapperExtra {\n  padding: 40px 8%;\n  text-align: left;\n}\n\n.title {\n  font-weight: 800;\n  margin-bottom: 20px;\n}\n\n.contentWrapperExtra h2 {\n    font-size: 40px;\n    color: #ffffff;\n}\n\n.title span {\n  color: var(--azul);\n    font-size: 34px;\n  font-weight: 800;\n  margin-bottom: 20px;\n  line-height: 1.3;\n\n}\n\n.paragraph {\n  font-size: 16px;\n  color: #ffffff;\n  line-height: 1.7;\n  margin-bottom: 30px;\n}\n\n.paragraph p {\n    color: #fff;\n}\n\n/* ===== Lista de Necesidades ===== */\n.needsList {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 40px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 15px; /* Espacio entre ítems de la lista */\n}\n\n.needsItem {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  font-size: 16px;\n  color: #d0d0d0;\n}\n\n.needsItem svg {\n  flex-shrink: 0; /* Evita que el ícono se encoja */\n  width: 24px;\n  height: 24px;\n  color: var(--azul); /* Color azul para el ícono */\n}\n\n/* ===== Tagline Final ===== */\n.tagline {\n  font-size: 28px;\n  font-weight: 700;\n  color: var(--textoBlanco);\n  line-height: 1.4;\n}\n\n.tagline span {\n  color: var(--azul);\n  font-size: 28px;\n}\n\n/* ===== MEDIA QUERY PARA MÓVILES ===== */\n@media (max-width: 767px) {\n  .heroSection h1 { font-size: 34px; }\n  .heroSection p { font-size: 16px; }\n  .learnMoreLink {\n    font-size: 14px;\n  }\n  .serviceItem {\n    grid-template-columns: 1fr; \n  }\n  .serviceItem:nth-child(even) .imageWrapper,\n  .serviceItem:nth-child(even) .contentWrapper {\n    order: initial;\n  }\n  .contentWrapper {\n    padding: 40px 8%;\n  }\n  .contentWrapper h2 {\n    font-size: 24px;\n  }\n  .containerExtra {\n    grid-template-columns: 1fr;\n  }\n  .contentWrapperExtra {\n    order: 2;\n    padding: 40px 8%;\n  }\n  .title {\n    font-size: 28px;\n  }\n  .tagline {\n    font-size: 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heroSection": `ServiciosIA_heroSection__0BNq9`,
	"heroBackground": `ServiciosIA_heroBackground__StL22`,
	"heroContent": `ServiciosIA_heroContent__TAZWz`,
	"ctaButton": `ServiciosIA_ctaButton__RvenQ`,
	"servicesSection": `ServiciosIA_servicesSection__cPVgS`,
	"serviceItem": `ServiciosIA_serviceItem__yb8RY`,
	"imageWrapper": `ServiciosIA_imageWrapper__JOOfL`,
	"contentWrapper": `ServiciosIA_contentWrapper__-MLQW`,
	"serviceImage": `ServiciosIA_serviceImage__0ARUo`,
	"learnMoreLink": `ServiciosIA_learnMoreLink__Z76yd`,
	"uniqueNeedsSection": `ServiciosIA_uniqueNeedsSection__+dHAz`,
	"containerExtra": `ServiciosIA_containerExtra__FcMXk`,
	"image": `ServiciosIA_image__-qM-Q`,
	"contentWrapperExtra": `ServiciosIA_contentWrapperExtra__ZEjEJ`,
	"title": `ServiciosIA_title__IMNzb`,
	"paragraph": `ServiciosIA_paragraph__zEVTX`,
	"needsList": `ServiciosIA_needsList__u9+Pa`,
	"needsItem": `ServiciosIA_needsItem__P7GBb`,
	"tagline": `ServiciosIA_tagline__ky6NL`
};
export default ___CSS_LOADER_EXPORT___;
